import {Directive, Input, OnDestroy, TemplateRef, ViewContainerRef} from '@angular/core';
import {FeatureFlagService}                                          from '@src/app/core/services/feature-flag.service';
import {Subscription}                                                from 'rxjs';

@Directive({
    standalone: false,
    selector: '[appFeatureFlag]'
})
export class FeatureFlagDirective implements OnDestroy
{
    private flagSubscription?: Subscription;
    private hasView = false;

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainerRef: ViewContainerRef,
        private featureFlagService: FeatureFlagService,
    )
    {
    }

    @Input()
    set appFeatureFlag(flagKey: string)
    {
        this.flagSubscription?.unsubscribe();

        this.flagSubscription = this.featureFlagService.getFlag(flagKey).subscribe((value) => {
            const enabled = Boolean(value);

            if (enabled && !this.hasView) {
                this.viewContainerRef.createEmbeddedView(this.templateRef);
                this.hasView = true;
            } else if (!enabled && this.hasView) {
                this.viewContainerRef.clear();
                this.hasView = false;
            }
        });
    }

    public ngOnDestroy(): void
    {
        this.flagSubscription?.unsubscribe();
    }
}
